export const LOGGER_PREFIX = "[AffiliateSDK]";

export const COOKIE_TEST = "__aff_test__";
export const COOKIE_SESSION = "aff_session";
export const COOKIE_REF = "aff_ref";
export const COOKIE_DISCOUNT = "aff_discount";
export const COOKIE_TOKEN = "aff_token";

export const COOKIE_PATH = "/";
export const COOKIE_SAME_SITE: "Lax" | "Strict" | "None" = "Lax";

export const DEFAULT_COOKIE_DURATION_DAYS = 30;
export const SESSION_DURATION_DAYS = 30 / (24 * 60); // 30 minutes

export const HTTP_RETRY_DELAY_MS = 2_000;
export const HTTP_MAX_RETRIES = 1;
export const HTTP_MAX_RETRY_AFTER_MS = 60_000;
export const HTTP_REQUEST_TIMEOUT_MS = 15_000;
export const HTTP_CREDENTIALS_MODE: RequestCredentials = "include";

export const EVENT_MAX_QUEUE_SIZE = 100;
export const EVENT_FLUSH_INTERVAL_MS = 5_000;
export const EVENT_BEACON_MAX_BYTES = 63_000;
export const EVENT_VALID_TYPES = new Set(["pageview", "click", "conversion", "identify", "custom"]);

export const AUTOTRACK_DEBOUNCE_MS = 300;

export const URL_PARAM_REF = "ref";
export const URL_PARAM_CT = "ct";
export const URL_PARAM_DISCOUNT = "discount";
export const URL_MAX_PARAM_LENGTH = 256;
export const URL_SAFE_CODE_PATTERN = /^[a-zA-Z0-9_-]+$/;

export const DEFAULT_TRACKING_DOMAIN =
  import.meta.env.VITE_TRACKING_DOMAIN || "https://api.yourcompany.com";
export const SDK_VERSION = import.meta.env.VITE_SDK_VERSION || "1.0.0";
export const DEFAULT_API_SECRET = import.meta.env.VITE_API_SECRET || "api-secret";

const API_BASE = "/api/v1";

export const API_PATH_INIT = `${API_BASE}/sdk/init`;
export const API_PATH_TRACK_CLICK = `${API_BASE}/track/click`;
export const API_PATH_TRACK_PAGEVIEW = `${API_BASE}/track/pageview`;

export const API_PATH_IDENTIFY = `${API_BASE}/track/identify`;
export const API_PATH_DISCOUNT_LOOKUP = `${API_BASE}/sdk/discount`;
export const API_PATH_DISCOUNT_VALIDATE = `${API_BASE}/sdk/discounts/validate`;
export const API_PATH_BATCH_EVENTS = `${API_BASE}/sdk/events`;

export const API_PATH_TRACK_ORDER = `${API_BASE}/track/conversion/order-data`;
export const API_PATH_TRACK_ADD_TO_CART = `${API_BASE}/track/add-to-cart`;
export const API_PATH_TRACK_REMOVE_FROM_CART = `${API_BASE}/track/remove-from-cart`;
export const API_PATH_TRACK_PRODUCT_VIEW = `${API_BASE}/track/product-view`;
export const API_PATH_TRACK_THANK_YOU_VIEW = `${API_BASE}/track/thank-you-view`;
export const API_PATH_TRACK_CHECKOUT = `${API_BASE}/track/checkout`;
